export const AccessApiKeyFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccessApiKey" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccessApiKey" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "userId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const AccountingTransactionFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccountingTransaction" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountingTransaction" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "transactionType" } },
                    { kind: "Field", name: { kind: "Name", value: "amount" } },
                    { kind: "Field", name: { kind: "Name", value: "balanceAfter" } },
                    { kind: "Field", name: { kind: "Name", value: "currency" } },
                    { kind: "Field", name: { kind: "Name", value: "referenceType" } },
                    { kind: "Field", name: { kind: "Name", value: "referenceId" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "creatorId" } },
                    { kind: "Field", name: { kind: "Name", value: "bookedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const AccountingBalanceFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccountingBalance" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountingBalance" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "balance" } },
                    { kind: "Field", name: { kind: "Name", value: "effectiveBalance" } },
                    { kind: "Field", name: { kind: "Name", value: "lastTransactionId" } },
                    { kind: "Field", name: { kind: "Name", value: "lastReconciledAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const AnswerReviewFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AnswerReview" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AnswerReview" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "messageId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "comment" } },
                    { kind: "Field", name: { kind: "Name", value: "done" } },
                    { kind: "Field", name: { kind: "Name", value: "question" } },
                    { kind: "Field", name: { kind: "Name", value: "rating" } },
                    { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const ApiKeyFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiKey" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiKey" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CallFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Call" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Call" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiCallId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "voicebotId" } },
                    { kind: "Field", name: { kind: "Name", value: "startedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "endedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "duration" } },
                    { kind: "Field", name: { kind: "Name", value: "customerPhoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const ApiToolFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ChatbotFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chatbot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chatbot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "defaultLanguage" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "fallbackMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "humanSupportHours" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                                { kind: "Field", name: { kind: "Name", value: "stopHour" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CustomerFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const UserFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const KnowledgeBaseFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const ChatMessageFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const ChatFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CostFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Cost" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Cost" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "startTime" } },
                    { kind: "Field", name: { kind: "Name", value: "endTime" } },
                    { kind: "Field", name: { kind: "Name", value: "value" } },
                    { kind: "Field", name: { kind: "Name", value: "currency" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const SpendingLimitFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "SpendingLimit" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SpendingLimit" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "limitAmount" } },
                    { kind: "Field", name: { kind: "Name", value: "period" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CustomerBranchFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "CustomerBranch" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CustomerBranch" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "companyName" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "address" } },
                    { kind: "Field", name: { kind: "Name", value: "zip" } },
                    { kind: "Field", name: { kind: "Name", value: "city" } },
                    { kind: "Field", name: { kind: "Name", value: "province" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtractPath" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtract" } },
                ],
            },
        },
    ],
};
export const FollowupFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Followup" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatFollowup" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "callId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "followupType" } },
                    { kind: "Field", name: { kind: "Name", value: "contactInfo" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "response" } },
                    { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const PlanFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Plan" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Plan" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "priceMonthly" } },
                    { kind: "Field", name: { kind: "Name", value: "yearlyDiscount" } },
                    { kind: "Field", name: { kind: "Name", value: "effectiveYearlyPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const PriceFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Price" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Price" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "model" } },
                    { kind: "Field", name: { kind: "Name", value: "inputTokenPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "outputTokenPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "priceStart" } },
                    { kind: "Field", name: { kind: "Name", value: "priceStop" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const SecretFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Secret" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Secret" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                            ],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const VoicebotFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Voicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "useIntro" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    { kind: "Field", name: { kind: "Name", value: "firstMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNoRequested" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiId" } },
                    { kind: "Field", name: { kind: "Name", value: "introPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "useKnowledgebases" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const BranchVoicebotFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "BranchVoicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BranchVoicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "voicebotId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "companyName" } },
                    { kind: "Field", name: { kind: "Name", value: "zip" } },
                    { kind: "Field", name: { kind: "Name", value: "city" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                ],
            },
        },
    ],
};
export const AccessApiKeysDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "accessApiKeys" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ListAccessApiKeysFilters" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "accessApiKeys" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AccessApiKey" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccessApiKey" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccessApiKey" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "userId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountAccessApiKeysDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countAccessApiKeys" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ListAccessApiKeysFilters" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countAccessApiKeys" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const CreateAccessApiKeyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "createAccessApiKey" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "AccessApiKeyInput" } },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "createAccessApiKey" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "apiKey" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AccessApiKey" } }],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "token" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccessApiKey" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccessApiKey" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "userId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const RevokeAccessApiKeyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "revokeAccessApiKey" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "revokeAccessApiKey" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AccessApiKey" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccessApiKey" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccessApiKey" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "userId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const AccountingBalanceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "accountingBalance" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "accountingBalance" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AccountingBalance" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccountingBalance" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountingBalance" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "balance" } },
                    { kind: "Field", name: { kind: "Name", value: "effectiveBalance" } },
                    { kind: "Field", name: { kind: "Name", value: "lastTransactionId" } },
                    { kind: "Field", name: { kind: "Name", value: "lastReconciledAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const AccountingTransactionsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "accountingTransactions" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "AccountingTransactionFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "accountingTransactions" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AccountingTransaction" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccountingTransaction" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountingTransaction" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "transactionType" } },
                    { kind: "Field", name: { kind: "Name", value: "amount" } },
                    { kind: "Field", name: { kind: "Name", value: "balanceAfter" } },
                    { kind: "Field", name: { kind: "Name", value: "currency" } },
                    { kind: "Field", name: { kind: "Name", value: "referenceType" } },
                    { kind: "Field", name: { kind: "Name", value: "referenceId" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "creatorId" } },
                    { kind: "Field", name: { kind: "Name", value: "bookedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountAccountingTransactionsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countAccountingTransactions" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "AccountingTransactionFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countAccountingTransactions" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const AccountingTransactionDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "accountingTransaction" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "accountingTransaction" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AccountingTransaction" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccountingTransaction" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountingTransaction" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "transactionType" } },
                    { kind: "Field", name: { kind: "Name", value: "amount" } },
                    { kind: "Field", name: { kind: "Name", value: "balanceAfter" } },
                    { kind: "Field", name: { kind: "Name", value: "currency" } },
                    { kind: "Field", name: { kind: "Name", value: "referenceType" } },
                    { kind: "Field", name: { kind: "Name", value: "referenceId" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "creatorId" } },
                    { kind: "Field", name: { kind: "Name", value: "bookedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CreateAdjustmentDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "createAdjustment" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "amount" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BigDecimal" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "createAdjustment" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "amount" },
                                value: { kind: "Variable", name: { kind: "Name", value: "amount" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "description" },
                                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AccountingTransaction" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AccountingTransaction" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountingTransaction" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "transactionType" } },
                    { kind: "Field", name: { kind: "Name", value: "amount" } },
                    { kind: "Field", name: { kind: "Name", value: "balanceAfter" } },
                    { kind: "Field", name: { kind: "Name", value: "currency" } },
                    { kind: "Field", name: { kind: "Name", value: "referenceType" } },
                    { kind: "Field", name: { kind: "Name", value: "referenceId" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "creatorId" } },
                    { kind: "Field", name: { kind: "Name", value: "bookedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const AnswerReviewsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "answerReviews" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "AnswerReviewListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "answerReviews" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "FragmentSpread", name: { kind: "Name", value: "AnswerReview" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AnswerReview" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AnswerReview" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "messageId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "comment" } },
                    { kind: "Field", name: { kind: "Name", value: "done" } },
                    { kind: "Field", name: { kind: "Name", value: "question" } },
                    { kind: "Field", name: { kind: "Name", value: "rating" } },
                    { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountAnswerReviewsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countAnswerReviews" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "AnswerReviewListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countAnswerReviews" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const AnswerReviewDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "answerReview" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "answerReview" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "FragmentSpread", name: { kind: "Name", value: "AnswerReview" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "chat" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AnswerReview" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AnswerReview" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "messageId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "comment" } },
                    { kind: "Field", name: { kind: "Name", value: "done" } },
                    { kind: "Field", name: { kind: "Name", value: "question" } },
                    { kind: "Field", name: { kind: "Name", value: "rating" } },
                    { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const MutateAnswerReviewDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateAnswerReview" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "AnswerReviewInput" } },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateAnswerReview" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "messageId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "messageId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "chatId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AnswerReview" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AnswerReview" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AnswerReview" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "messageId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "comment" } },
                    { kind: "Field", name: { kind: "Name", value: "done" } },
                    { kind: "Field", name: { kind: "Name", value: "question" } },
                    { kind: "Field", name: { kind: "Name", value: "rating" } },
                    { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const DeleteAnswerReviewDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteAnswerReview" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteAnswerReview" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AnswerReview" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AnswerReview" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AnswerReview" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "messageId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "comment" } },
                    { kind: "Field", name: { kind: "Name", value: "done" } },
                    { kind: "Field", name: { kind: "Name", value: "question" } },
                    { kind: "Field", name: { kind: "Name", value: "rating" } },
                    { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const MarkAnswerReviewDoneDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "markAnswerReviewDone" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "markAnswerReviewDone" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AnswerReview" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "AnswerReview" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AnswerReview" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "messageId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "comment" } },
                    { kind: "Field", name: { kind: "Name", value: "done" } },
                    { kind: "Field", name: { kind: "Name", value: "question" } },
                    { kind: "Field", name: { kind: "Name", value: "rating" } },
                    { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const GetNextReviewAnswerDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "getNextReviewAnswer" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "start" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "NaiveDateTime" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "stop" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "NaiveDateTime" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "getNextReviewAnswer" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "start" },
                                value: { kind: "Variable", name: { kind: "Name", value: "start" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "stop" },
                                value: { kind: "Variable", name: { kind: "Name", value: "stop" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "messageId" } },
                                { kind: "Field", name: { kind: "Name", value: "question" } },
                                { kind: "Field", name: { kind: "Name", value: "answer" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "chatId" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "knowledgeBases" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "chat" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ReviewCountsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "reviewCounts" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "start" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "NaiveDateTime" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "stop" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "NaiveDateTime" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewCounts" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "start" },
                                value: { kind: "Variable", name: { kind: "Name", value: "start" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "stop" },
                                value: { kind: "Variable", name: { kind: "Name", value: "stop" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "total" } },
                                { kind: "Field", name: { kind: "Name", value: "unreviewed" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ApiKeysDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "apiKeys" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ApiKeysListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiKeys" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiKey" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiKey" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiKey" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountApiKeysDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countApiKeys" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ApiKeysListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countApiKeys" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const ApiKeyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "apiKey" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiKey" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiKey" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiKey" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiKey" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const MutateApiKeyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateApiKey" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ApiKeyInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateApiKey" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiKey" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiKey" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiKey" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const DeleteApiKeyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteApiKey" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteApiKey" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ApiToolsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "apiTools" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ApiToolsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CountApiToolsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countApiTools" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countApiTools" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const ApiToolDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "apiTool" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTool" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const MutateApiToolDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateApiTool" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ApiToolInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateApiTool" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteApiToolDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteApiTool" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteApiTool" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const CallsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "calls" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "CallsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "calls" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Call" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Call" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Call" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiCallId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "voicebotId" } },
                    { kind: "Field", name: { kind: "Name", value: "startedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "endedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "duration" } },
                    { kind: "Field", name: { kind: "Name", value: "customerPhoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountCallsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countCalls" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "CallsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countCalls" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const DeleteCallDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteCall" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteCall" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const MutateChatbotDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateChatbot" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ChatbotInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateChatbot" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chatbot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chatbot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chatbot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "defaultLanguage" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "fallbackMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "humanSupportHours" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                                { kind: "Field", name: { kind: "Name", value: "stopHour" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteChatbotDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteChatbot" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteChatbot" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chatbot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chatbot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chatbot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "defaultLanguage" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "fallbackMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "humanSupportHours" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                                { kind: "Field", name: { kind: "Name", value: "stopHour" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ChatbotsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "chatbots" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ChatbotsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "chatbots" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chatbot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chatbot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chatbot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "defaultLanguage" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "fallbackMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "humanSupportHours" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                                { kind: "Field", name: { kind: "Name", value: "stopHour" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CountChatbotsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countChatbots" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countChatbots" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const ChatbotDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "chatbot" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "chatbot" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chatbot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chatbot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chatbot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "defaultLanguage" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "fallbackMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "humanSupportHours" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                                { kind: "Field", name: { kind: "Name", value: "stopHour" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ChatsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "chats" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ChatsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "chats" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CountChatsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countChats" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ChatsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countChats" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const GetChatDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "getChat" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "chat" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ChatMessagesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "chatMessages" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "chatMessages" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "chatId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const OwnChatDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "ownChat" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "ownChat" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const AssignChatDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "assignChat" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignChat" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "userId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CloseChatDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "closeChat" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "closeChat" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const SendChatMessageDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "sendChatMessage" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "message" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sendChatMessage" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "chatId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "message" },
                                value: { kind: "Variable", name: { kind: "Name", value: "message" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const ChatMessageEventsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "subscription",
            name: { kind: "Name", value: "chatMessageEvents" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "chatMessageEvents" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "chatId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "chatId" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const ChatEventsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "subscription",
            name: { kind: "Name", value: "chatEvents" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "chatEvents" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CostsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "costs" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "CostsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "costs" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Cost" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Cost" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Cost" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "startTime" } },
                    { kind: "Field", name: { kind: "Name", value: "endTime" } },
                    { kind: "Field", name: { kind: "Name", value: "value" } },
                    { kind: "Field", name: { kind: "Name", value: "currency" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountCostsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countCosts" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "CostsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countCosts" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const SpendingLimitsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "spendingLimits" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "spendingLimits" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SpendingLimit" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "SpendingLimit" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SpendingLimit" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "limitAmount" } },
                    { kind: "Field", name: { kind: "Name", value: "period" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const MutateSpendingLimitDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateSpendingLimit" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "SpendingLimitInput" } },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateSpendingLimit" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SpendingLimit" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "SpendingLimit" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SpendingLimit" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "limitAmount" } },
                    { kind: "Field", name: { kind: "Name", value: "period" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const DeleteSpendingLimitDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteSpendingLimit" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteSpendingLimit" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const AbsoluteCostsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "absoluteCosts" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "period" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CostPeriod" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "absoluteCosts" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "period" },
                                value: { kind: "Variable", name: { kind: "Name", value: "period" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const CustomerBranchesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "customerBranches" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "CustomerBranchFilters" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customerBranches" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CustomerBranch" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "CustomerBranch" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CustomerBranch" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "companyName" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "address" } },
                    { kind: "Field", name: { kind: "Name", value: "zip" } },
                    { kind: "Field", name: { kind: "Name", value: "city" } },
                    { kind: "Field", name: { kind: "Name", value: "province" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtractPath" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtract" } },
                ],
            },
        },
    ],
};
export const CountCustomerBranchesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countCustomerBranches" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "CustomerBranchFilters" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countCustomerBranches" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const CustomerBranchDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "customerBranch" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customerBranch" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CustomerBranch" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "CustomerBranch" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CustomerBranch" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "companyName" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "address" } },
                    { kind: "Field", name: { kind: "Name", value: "zip" } },
                    { kind: "Field", name: { kind: "Name", value: "city" } },
                    { kind: "Field", name: { kind: "Name", value: "province" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtractPath" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtract" } },
                ],
            },
        },
    ],
};
export const MutateCustomerBranchDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateCustomerBranch" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "CustomerBranchInput" } },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateCustomerBranch" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CustomerBranch" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "CustomerBranch" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CustomerBranch" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "companyName" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "address" } },
                    { kind: "Field", name: { kind: "Name", value: "zip" } },
                    { kind: "Field", name: { kind: "Name", value: "city" } },
                    { kind: "Field", name: { kind: "Name", value: "province" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtractPath" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtract" } },
                ],
            },
        },
    ],
};
export const UpdateCustomerBranchStatusDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "updateCustomerBranchStatus" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BranchStatus" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "updateCustomerBranchStatus" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "status" },
                                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CustomerBranch" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "CustomerBranch" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CustomerBranch" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "companyName" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "address" } },
                    { kind: "Field", name: { kind: "Name", value: "zip" } },
                    { kind: "Field", name: { kind: "Name", value: "city" } },
                    { kind: "Field", name: { kind: "Name", value: "province" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtractPath" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "commercialRegisterExtract" } },
                ],
            },
        },
    ],
};
export const UploadCommercialRegisterExtractDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "uploadCommercialRegisterExtract" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "branchId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "fileName" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "uploadCommercialRegisterExtract" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "branchId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "branchId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "fileName" },
                                value: { kind: "Variable", name: { kind: "Name", value: "fileName" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CustomerBranchIsVerifiedDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "customerBranchIsVerified" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customerBranchIsVerified" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const MutateCustomerDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateCustomer" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CustomerInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateCustomer" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const DeleteCustomerDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteCustomer" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteCustomer" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CustomersDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "customers" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "CustomersListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customers" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountCustomersDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countCustomers" },
            selectionSet: {
                kind: "SelectionSet",
                selections: [{ kind: "Field", name: { kind: "Name", value: "countCustomers" } }],
            },
        },
    ],
};
export const CustomerDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "customer" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const UploadCustomerLogoDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "uploadCustomerLogo" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "fileName" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "uploadCustomerLogo" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "fileName" },
                                value: { kind: "Variable", name: { kind: "Name", value: "fileName" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "url" } },
                                { kind: "Field", name: { kind: "Name", value: "path" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DashboardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "dashboard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DashboardFilters" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "dashboard" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "overview" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "total" } },
                                            { kind: "Field", name: { kind: "Name", value: "resolvedByAi" } },
                                            { kind: "Field", name: { kind: "Name", value: "resolvedByUser" } },
                                            { kind: "Field", name: { kind: "Name", value: "waitingChats" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "chatsCreated" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "aiPerformance" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "resolvedByUser" } },
                                            { kind: "Field", name: { kind: "Name", value: "resolvedByBot" } },
                                            { kind: "Field", name: { kind: "Name", value: "notResolved" } },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "answerReview" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "name" } },
                                            { kind: "Field", name: { kind: "Name", value: "correct" } },
                                            { kind: "Field", name: { kind: "Name", value: "wrong" } },
                                            { kind: "Field", name: { kind: "Name", value: "neutral" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "avgDuration" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const DemoVoiceSampleDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "demoVoiceSample" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "voiceId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "demoVoiceSample" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "voiceId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "voiceId" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const DemoRegistrationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "demoRegistration" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "account" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "DemoAccountInfosInput" } },
                    },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "chatbot" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "DemoChatbotInfosInput" } },
                    },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "rawData" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "knowledgebase" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "botType" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DemoBotType" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "demoRegistration" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "account" },
                                value: { kind: "Variable", name: { kind: "Name", value: "account" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "chatbot" },
                                value: { kind: "Variable", name: { kind: "Name", value: "chatbot" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "rawData" },
                                value: { kind: "Variable", name: { kind: "Name", value: "rawData" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "knowledgebase" },
                                value: { kind: "Variable", name: { kind: "Name", value: "knowledgebase" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "botType" },
                                value: { kind: "Variable", name: { kind: "Name", value: "botType" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "token" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "customer" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "chatbot" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "id" } },
                                            { kind: "Field", name: { kind: "Name", value: "name" } },
                                            { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "voicebot" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "id" } },
                                            { kind: "Field", name: { kind: "Name", value: "name" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const FollowupsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "followups" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ChatFollowupsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "followups" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Followup" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Followup" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatFollowup" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "callId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "followupType" } },
                    { kind: "Field", name: { kind: "Name", value: "contactInfo" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "response" } },
                    { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountFollowupsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countFollowups" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ChatFollowupsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countFollowups" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const GetFollowupDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "getFollowup" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "followup" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "FragmentSpread", name: { kind: "Name", value: "Followup" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "chat" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "messages" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Followup" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatFollowup" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "callId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "followupType" } },
                    { kind: "Field", name: { kind: "Name", value: "contactInfo" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "response" } },
                    { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteFollowupDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteFollowup" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteFollowup" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Followup" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Followup" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatFollowup" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "callId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "followupType" } },
                    { kind: "Field", name: { kind: "Name", value: "contactInfo" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "response" } },
                    { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const RespondFollowupDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "respondFollowup" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "response" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "respondFollowup" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "response" },
                                value: { kind: "Variable", name: { kind: "Name", value: "response" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Followup" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Followup" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatFollowup" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "callId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "followupType" } },
                    { kind: "Field", name: { kind: "Name", value: "contactInfo" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "response" } },
                    { kind: "Field", name: { kind: "Name", value: "respondedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const MutateKnowledgeBaseDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateKnowledgeBase" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBaseInput" } },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateKnowledgeBase" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const DeleteKnowledgeBaseDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteKnowledgeBase" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteKnowledgeBase" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const KnowledgeBasesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "knowledgeBases" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBasesListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountKnowledgeBasesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countKnowledgeBases" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countKnowledgeBases" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const OptimizeKnowledgeBaseDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "optimizeKnowledgeBase" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "content" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "lang" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Language" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "optimizeKnowledgeBase" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "content" },
                                value: { kind: "Variable", name: { kind: "Name", value: "content" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "lang" },
                                value: { kind: "Variable", name: { kind: "Name", value: "lang" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const KnowledgeBaseDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "knowledgeBase" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBase" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const PlansDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "plans" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "PlansListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "plans" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Plan" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Plan" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Plan" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "priceMonthly" } },
                    { kind: "Field", name: { kind: "Name", value: "yearlyDiscount" } },
                    { kind: "Field", name: { kind: "Name", value: "effectiveYearlyPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountPlansDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countPlans" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "PlansListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countPlans" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const PlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "plan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "plan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Plan" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Plan" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Plan" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "priceMonthly" } },
                    { kind: "Field", name: { kind: "Name", value: "yearlyDiscount" } },
                    { kind: "Field", name: { kind: "Name", value: "effectiveYearlyPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const MutatePlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutatePlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PlanInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutatePlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Plan" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Plan" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Plan" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "priceMonthly" } },
                    { kind: "Field", name: { kind: "Name", value: "yearlyDiscount" } },
                    { kind: "Field", name: { kind: "Name", value: "effectiveYearlyPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const ChangePlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "changePlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ChangePlanInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "changePlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Plan" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Plan" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Plan" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "priceMonthly" } },
                    { kind: "Field", name: { kind: "Name", value: "yearlyDiscount" } },
                    { kind: "Field", name: { kind: "Name", value: "effectiveYearlyPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const DeletePlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deletePlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deletePlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const PricesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "prices" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "PricesListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prices" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Price" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Price" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Price" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "model" } },
                    { kind: "Field", name: { kind: "Name", value: "inputTokenPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "outputTokenPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "priceStart" } },
                    { kind: "Field", name: { kind: "Name", value: "priceStop" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountPricesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countPrices" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "PricesListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countPrices" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const PriceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "price" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "price" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Price" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Price" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Price" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "model" } },
                    { kind: "Field", name: { kind: "Name", value: "inputTokenPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "outputTokenPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "priceStart" } },
                    { kind: "Field", name: { kind: "Name", value: "priceStop" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const MutatePriceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutatePrice" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PriceInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutatePrice" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Price" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Price" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Price" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "service" } },
                    { kind: "Field", name: { kind: "Name", value: "model" } },
                    { kind: "Field", name: { kind: "Name", value: "inputTokenPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "outputTokenPrice" } },
                    { kind: "Field", name: { kind: "Name", value: "priceStart" } },
                    { kind: "Field", name: { kind: "Name", value: "priceStop" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const DeletePriceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deletePrice" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deletePrice" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const GlobalSearchDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "globalSearch" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "term" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "globalSearch" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "term" },
                                value: { kind: "Variable", name: { kind: "Name", value: "term" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "chats" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chat" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "users" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "knowledgeBases" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "chatbots" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Chatbot" } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "KnowledgeBase" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KnowledgeBase" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "lang" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ChatMessage" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ChatMessage" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "chatId" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "messageType" } },
                    { kind: "Field", name: { kind: "Name", value: "content" } },
                    { kind: "Field", name: { kind: "Name", value: "senderId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "usedKnowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KnowledgeBase" } }],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chat" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chat" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "needsHuman" } },
                    { kind: "Field", name: { kind: "Name", value: "assignedToId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "chatbotId" } },
                    { kind: "Field", name: { kind: "Name", value: "sessionId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedTo" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "lastMessage" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ChatMessage" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Chatbot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Chatbot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "defaultLanguage" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "fallbackMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "humanSupportHours" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                                { kind: "Field", name: { kind: "Name", value: "stopHour" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const SecretsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "secrets" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ListSecretsFilters" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "secrets" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Secret" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Secret" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Secret" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                            ],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const CountSecretsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countSecrets" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ListSecretsFilters" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countSecrets" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const SecretDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "secret" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "secret" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Secret" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Secret" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Secret" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                            ],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const MutateSecretDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateSecret" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "SecretInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateSecret" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Secret" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Secret" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Secret" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                            ],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const DeleteSecretDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteSecret" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteSecret" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Secret" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Secret" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Secret" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                            ],
                        },
                    },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
    ],
};
export const LoginDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "login" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "password" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "login" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "email" },
                                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "password" },
                                value: { kind: "Variable", name: { kind: "Name", value: "password" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const SessionDataDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "sessionData" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerIdentifier" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "sessionData" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerIdentifier" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerIdentifier" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "customer" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const RefreshDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "refresh" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerIdentifier" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "refresh" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerIdentifier" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerIdentifier" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "token" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "customer" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CreateCheckoutSessionDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "createCheckoutSession" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "amountCents" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "createCheckoutSession" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "amountCents" },
                                value: { kind: "Variable", name: { kind: "Name", value: "amountCents" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "checkoutUrl" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const MutateUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateUser" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateUser" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteUser" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteUser" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UsersDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "users" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "UsersListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "users" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CountUsersDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countUsers" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "UsersCountFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countUsers" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const UserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "user" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UploadUserAvatarDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "uploadUserAvatar" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "fileName" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "uploadUserAvatar" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "fileName" },
                                value: { kind: "Variable", name: { kind: "Name", value: "fileName" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "url" } },
                                { kind: "Field", name: { kind: "Name", value: "path" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const RequestPasswordResetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "requestPasswordReset" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "requestPasswordReset" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "email" },
                                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ValidatePasswordResetTokenDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "validatePasswordResetToken" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "validatePasswordResetToken" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "token" },
                                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const ConfirmEmailDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "confirmEmail" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmEmail" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "token" },
                                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const ConfirmPasswordResetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "confirmPasswordReset" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "newPassword" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmPasswordReset" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "token" },
                                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "newPassword" },
                                value: { kind: "Variable", name: { kind: "Name", value: "newPassword" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const SetUserStatusDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "setUserStatus" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserStatus" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "setUserStatus" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "status" },
                                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const UserStatusDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "userStatus" },
            selectionSet: {
                kind: "SelectionSet",
                selections: [{ kind: "Field", name: { kind: "Name", value: "userStatus" } }],
            },
        },
    ],
};
export const UserStatusEventsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "subscription",
            name: { kind: "Name", value: "userStatusEvents" },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userStatusEvents" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "User" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Customer" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Customer" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    { kind: "Field", name: { kind: "Name", value: "logo" } },
                    { kind: "Field", name: { kind: "Name", value: "demoStartedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "demoExpired" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "User" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "email" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "firstname" } },
                    { kind: "Field", name: { kind: "Name", value: "lastname" } },
                    { kind: "Field", name: { kind: "Name", value: "avatar" } },
                    { kind: "Field", name: { kind: "Name", value: "role" } },
                    { kind: "Field", name: { kind: "Name", value: "status" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "confirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmail" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "pendingEmailConfirmationSentAt" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "userCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "adminCustomers" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Customer" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const MutateVoicebotDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "mutateVoicebot" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "values" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "VoicebotInput" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "mutateVoicebot" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "values" },
                                value: { kind: "Variable", name: { kind: "Name", value: "values" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Voicebot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Voicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "useIntro" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    { kind: "Field", name: { kind: "Name", value: "firstMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNoRequested" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiId" } },
                    { kind: "Field", name: { kind: "Name", value: "introPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "useKnowledgebases" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const DeleteVoicebotDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteVoicebot" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteVoicebot" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Voicebot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Voicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "useIntro" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    { kind: "Field", name: { kind: "Name", value: "firstMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNoRequested" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiId" } },
                    { kind: "Field", name: { kind: "Name", value: "introPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "useKnowledgebases" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const VoicebotsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "voicebots" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "VoicebotsListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "voicebots" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Voicebot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Voicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "useIntro" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    { kind: "Field", name: { kind: "Name", value: "firstMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNoRequested" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiId" } },
                    { kind: "Field", name: { kind: "Name", value: "introPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "useKnowledgebases" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const CountVoicebotsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countVoicebots" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countVoicebots" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const VoicebotDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "voicebot" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "voicebot" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Voicebot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Voicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "useIntro" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    { kind: "Field", name: { kind: "Name", value: "firstMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNoRequested" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiId" } },
                    { kind: "Field", name: { kind: "Name", value: "introPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "useKnowledgebases" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const RequestVoicebotPhoneNumberDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "requestVoicebotPhoneNumber" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "requestVoicebotPhoneNumber" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "customerId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Voicebot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Voicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "useIntro" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    { kind: "Field", name: { kind: "Name", value: "firstMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNoRequested" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiId" } },
                    { kind: "Field", name: { kind: "Name", value: "introPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "useKnowledgebases" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
export const GlobalBranchVoicebotsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "globalBranchVoicebots" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "BranchVoicebotListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "globalBranchVoicebots" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BranchVoicebot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "BranchVoicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BranchVoicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "voicebotId" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "companyName" } },
                    { kind: "Field", name: { kind: "Name", value: "zip" } },
                    { kind: "Field", name: { kind: "Name", value: "city" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                ],
            },
        },
    ],
};
export const CountBranchVoicebotsGlobalDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "countBranchVoicebotsGlobal" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "BranchVoicebotListFilter" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "countBranchVoicebotsGlobal" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "filters" },
                                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export const AssignVoicebotPhoneNumberDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "assignVoicebotPhoneNumber" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StringNumber" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "phoneNo" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "assignVoicebotPhoneNumber" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "phoneNo" },
                                value: { kind: "Variable", name: { kind: "Name", value: "phoneNo" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Voicebot" } }],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "ApiTool" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ApiTool" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "description" } },
                    { kind: "Field", name: { kind: "Name", value: "url" } },
                    { kind: "Field", name: { kind: "Name", value: "method" } },
                    { kind: "Field", name: { kind: "Name", value: "headers" } },
                    { kind: "Field", name: { kind: "Name", value: "authType" } },
                    { kind: "Field", name: { kind: "Name", value: "authDetails" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "parameters" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "apiToolId" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "description" } },
                                { kind: "Field", name: { kind: "Name", value: "type" } },
                                { kind: "Field", name: { kind: "Name", value: "required" } },
                                { kind: "Field", name: { kind: "Name", value: "location" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: "FragmentDefinition",
            name: { kind: "Name", value: "Voicebot" },
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voicebot" } },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    { kind: "Field", name: { kind: "Name", value: "id" } },
                    { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    { kind: "Field", name: { kind: "Name", value: "name" } },
                    { kind: "Field", name: { kind: "Name", value: "active" } },
                    { kind: "Field", name: { kind: "Name", value: "publicToken" } },
                    { kind: "Field", name: { kind: "Name", value: "useIntro" } },
                    { kind: "Field", name: { kind: "Name", value: "modelName" } },
                    { kind: "Field", name: { kind: "Name", value: "firstMessage" } },
                    { kind: "Field", name: { kind: "Name", value: "config" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNo" } },
                    { kind: "Field", name: { kind: "Name", value: "phoneNoRequested" } },
                    { kind: "Field", name: { kind: "Name", value: "vapiId" } },
                    { kind: "Field", name: { kind: "Name", value: "introPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "systemPrompt" } },
                    { kind: "Field", name: { kind: "Name", value: "useKnowledgebases" } },
                    { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                    { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBases" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "id" } },
                                { kind: "Field", name: { kind: "Name", value: "name" } },
                                { kind: "Field", name: { kind: "Name", value: "lang" } },
                                { kind: "Field", name: { kind: "Name", value: "content" } },
                                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                            ],
                        },
                    },
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "apiTools" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ApiTool" } }],
                        },
                    },
                ],
            },
        },
    ],
};
